export default "__VITE_ASSET__9qpN7nlP__"